<template>
    <!-- eslint-disable max-len -->
    <svg :class="className" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#16273D"/>
        <circle cx="20" cy="20" r="9.5" stroke="white" fill="#16273D"/>
        <path d="M20.577 24.4121H19.285V18.5968H20.577V24.4121ZM19.208 16.7203C19.208 16.4893 19.2703 16.3116 19.3949 16.1869C19.5232 16.0623 19.7047 16 19.9393 16C20.1665 16 20.3425 16.0623 20.4671 16.1869C20.5954 16.3116 20.6595 16.4893 20.6595 16.7203C20.6595 16.9402 20.5954 17.1143 20.4671 17.2426C20.3425 17.3672 20.1665 17.4295 19.9393 17.4295C19.7047 17.4295 19.5232 17.3672 19.3949 17.2426C19.2703 17.1143 19.208 16.9402 19.208 16.7203Z" fill="white"/>
    </svg>
    <!-- eslint-enable max-len -->
</template>

<script>
export default {props: ['className']};
</script>
